/**
 * Stable, browser-independent sentinel for a network-level failure (offline, DNS,
 * unreachable host). `fetch()` rejects with a `TypeError` whose message differs per
 * browser ("Failed to fetch" / "NetworkError…" / "Load failed"), so `api.ts`
 * normalizes to this code and the display site translates it (see AuthModal,
 * `utils/arena-error-key.ts`).
 *
 * Sta in un file suo, e non dentro `services/api.ts`, per una ragione pratica:
 * chi traduce un errore ha bisogno della costante, non del client HTTP. Finché
 * viveva in `api.ts`, importarla significava tirarsi dietro l'intero client —
 * e ogni test che sostituisce `../services/api` con un finto faceva esplodere
 * il modulo che la leggeva («No "NETWORK_ERROR_CODE" export is defined on the
 * mock»), in sei file di test tutti insieme. `api.ts` la riesporta, così chi
 * la importava da lì non si accorge di niente.
 */
export const NETWORK_ERROR_CODE = 'NETWORK_ERROR';
